import React from "react";
import "./ContactNavLink.scss";

export interface ContactLink {
  name: string;
  href: string;
  iconSrc: string;
  external?: boolean;
}

const linkRegex = /(?:\w*:\/{0,2})?(.*)/;

function ContactNavLink({ name, href, iconSrc, external }: ContactLink) {
  return (
    <div>
      {(external && (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="contact-nav-link"
        >
          <div className={`${name} icon`}>
            <img src={iconSrc} alt={`${name} icon`} />
          </div>
          <div>{linkRegex.exec(href)?.[1]}</div>
        </a>
      )) || (
        <a href={href} className="contact-nav-link">
          <div className={`${name} icon`}>
            <img src={iconSrc} alt={`${name} icon`} />
          </div>
          <p>{linkRegex.exec(href)?.[1]}</p>
        </a>
      )}
    </div>
  );
}
export { ContactNavLink as default };
